"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRadio = void 0;
const react_1 = __importDefault(require("react"));
require("./input-radio.css");
/**
  * Main component.
  * @name InputRadio
  * @param {InputRadioProps}
  * @returns {<InputRadio />}
*/
const InputRadio = ({ inputLabel, onChange, disabled, values, }) => {
    return (react_1.default.createElement("div", { className: "input-radio-wrapper" },
        react_1.default.createElement("div", { className: disabled ? "input-radio-group-disabled" : "input-radio-group", "data-testid": "input-radio-element" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: "input-radio-title" }, inputLabel)),
            react_1.default.createElement("div", { className: "radios-wrapper" }, values &&
                values.map(({ id, value, name, isChecked, labelDesktop, labelMobile }, index) => {
                    return (react_1.default.createElement("div", { className: "input-radio-label", key: index },
                        react_1.default.createElement("input", { type: "radio", id: id, value: value, onChange: onChange, className: disabled ? "input-radio-disabled" : "input-radio", name: name, disabled: disabled, checked: isChecked }),
                        react_1.default.createElement("label", { className: "label-input-radio-desktop", htmlFor: id }, labelDesktop),
                        react_1.default.createElement("label", { className: "label-input-radio-mobile", htmlFor: id }, labelMobile)));
                })))));
};
exports.InputRadio = InputRadio;
//# sourceMappingURL=input-radio.js.map